import { render, staticRenderFns } from "./LiveListPage.vue?vue&type=template&id=37eadb7f&scoped=true"
import script from "./LiveListPage.vue?vue&type=script&lang=js"
export * from "./LiveListPage.vue?vue&type=script&lang=js"
import style0 from "./LiveListPage.vue?vue&type=style&index=0&id=37eadb7f&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37eadb7f",
  null
  
)

export default component.exports